export enum OfferStatus {
  Win = 'win',
  Loss = 'loss',
  New = 'new',
  InProgress = 'inProgress',
  Closed = 'closed',
  Anonymized = 'anonymized',
}
